import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import PageHeader from './PageHeader';

import './style.scss';
import LanguageSwitcher from "../LanguageSwitcher/index.jsx";

export default function Page({
  title,
  hasBack = false,
  children,
  pageClass = '',
  contentClass = '',
  contentRef,
  noSidebar = false,
  customHeaderItems = null
}) {
  return (
    <div className={cx('page', pageClass, { ['page__no-sidebar']: noSidebar })}>
      {title && (
        <PageHeader title={title} hasBack={hasBack}>
          {customHeaderItems}
          <LanguageSwitcher/>
        </PageHeader>
      )}
      <div className={cx('page__content', contentClass)} ref={contentRef}>
        {children}
      </div>
    </div>
  );
}

Page.propTypes = {
  title: PropTypes.string,
  hasBack: PropTypes.bool,
  children: PropTypes.node,
  pageClass: PropTypes.string,
  contentClass: PropTypes.string,
  noSidebar: PropTypes.bool
};
